import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './FragmentLinking.scss';

export default class FragmentLinking {

  constructor($view) {

    this.H_CODE = 'code';
    this.H_TAB = 'tab';

    this.$view = $view;
    this.$list = this.$view.find('.js-list-dealers');

    this.loadUrl = this.$view.data('load-url');
    this.selectUrl = this.$view.data('select-url');

    this.checkoutHash = this.$view.data('checkout-hash');

    this.linkingDisabled = parseInt(this.$view.data('linkingDisabled'));

    this.tabName = this.readHash(this.H_TAB);

    this.dealerCode = this.readHash(this.H_CODE);
    this.dealers = [];
    this.inRange = [];

    this.$map = null;
    this.$init = true;

    this.searchError = this.$view.find('.search-error');

    this.gtmMenuDealer();
    this.filterMarkers(false);

    this.bind();
  }


  bind() {

    this.$view.on('click', '.js-list-dealers .custom-control-label', (e) => {
      let code = $(e.currentTarget).closest('.custom-control.custom-radio').data('dealer');
      let dealer = this.findDealerByCode(code);
      this.showDealer(dealer);
    });

    this.$view.on('click', '.search-container button', (e) => {
      this.filterMarkers();
    });

    this.$view.on('click', '.js-linking-tab', (e) => {
      this.tabName = $(e.currentTarget).data('name');
      this.writeHash(this.H_TAB, this.tabName);
      this.selectDealer(null);

      this.renderTab();
    });

    this.$view.on('click', '.js-select-dealer', (e) => {
      e.preventDefault();

      const code = $(e.currentTarget).data('dealer');
      const dealer = this.findDealerByCode(code);
      this.selectDealer(dealer, e.currentTarget.classList.contains('js-phone'));
    });

    this.$view.on('keyup', '#city', (e) => {
      $(".js-autocomplete").remove();
      let city = this.$view.find('#city').val();

      if (city.length >= 3) {
        this.completeCity(city);
      }

      if (event.keyCode === 13) {
        if (city.length <= 2) {
          this.searchError.html("Veuillez saisir un code postal complet à 5 chiffres ou un nom de ville.");
          return;
        }

        this.filterMarkers();
      }
    });

    this.$view.on('blur', '#city', (e) => {
      $(".js-autocomplete").remove();
    });


    this.$view.on('submit', '#linkingForm', (e) => {
      this.scrollToElement($(".list-and-map"));
      this.gtmMerConfirm();
    });

  }

  completeCity(search) {
    let autocomplete = $("<div class='js-autocomplete address-autocomplete'></div>");

    $.ajax({
      url: 'https://geo.api.gouv.fr/communes',
      method: 'get',
      data: {'nom': search, 'boost': 'population', 'limit': 5},
      success: (results) => {
        $.map(results, (item) => {
          let i = Math.floor(Math.random() * Math.floor(100000));

          let name = item.nom;
          if (item.codesPostaux.length > 0) {
            name += " " + item.codesPostaux[0];
          }

          let $result = $("<a id='" + i + "'>" + name + "</a>");
          autocomplete.append($result);

          this.$view.on("mousedown", "#" + i, (e) => {
            this.$view.find('#city').val(name.toUpperCase());
            $(".js-autocomplete").remove();
          });
        });

        this.$view.find('#city').after(autocomplete);
      }
    });
  }

  // handlers

  loadDealers(point, radius, init) {
    $.ajax({
      url: this.loadUrl,
      method: 'get',
      data: {radius: radius, lat: point.lat, lng: point.lng},
      success: (data) => {
        // maj list of dealers

        this.dealers.forEach((dealer) => {
          this.$map.removeLayer(dealer.marker);
        });

        this.dealers = [];
        console.log(data);
        for (const dealer of data) {
          if (dealer.latitude !== undefined && dealer.longitude !== undefined) {
            this.dealers.push(dealer);
            this.inRange.push(dealer);
          }
        }

        if (this.$init) {
          this.$view.find('div.map-and-tab').css('display', 'block')
          this.renderMap();
        }

        // render list of dealers
        this.renderDealers();

        this.countResult((!this.$view.hasClass('widget-linking-filtered')));

        // select dealer if necessary
        if (this.dealerCode){
          let dealer = this.findDealerByCode(this.dealerCode);
          if (dealer){
            this.showDealer(dealer);
            this.selectDealer(dealer);
          }
        }

        this.zoomToPoint(point, radius);

      },
      error: () => {
        console.log("Error loading dealers");
      }
    });
  }

  filterMarkers(triggerError = true) {

    window.dataLayer.push({"event":"search-dealer"});

    console.log('filterMarkers');

    this.searchError.html("");

    const radius = parseInt(this.$view.find('#radiusSelect').val());
    const city = this.$view.find('#city').val();
    let address = city.trim();

    if (address === "") {

      if (triggerError) {
        this.searchError.html("Veuillez saisir un code postal complet à 5 chiffres ou un nom de ville.")
      }

      return;
    }

    this.searchError.html('<span class="text-body font-italic">Recherche en cours</span>');

    $.ajax({
      url: 'https://api-adresse.data.gouv.fr/search/',
      method: 'get',
      data: {'q': address},
      success: (results) => {
        console.log('filterMarkers results');
        if (results.features.length == 0) {
          this.searchError.html("Veuillez saisir un code postal complet à 5 chiffres ou un nom de ville.")
          return;
        }
        this.searchError.html("");

        const point = L.latLng([results.features[0].geometry.coordinates[1], results.features[0].geometry.coordinates[0]]);
        this.loadDealers(point, radius);
      }
    });

  }

  selectDealer(dealer, showPhone = false) {

    if (!dealer){
      console.log('unselect dealer');

      this.dealer = null;
      this.writeHash(this.H_CODE, null);

      // on efface le formulaire courament sélectionné
      this.$view.find('.js-linking-form').html('');

      return;
    }

    console.log('select dealer : ' + dealer.code);
    this.dealer = dealer;

    this.writeHash(this.H_CODE, dealer.code);

    if (!showPhone && this.isLinkingEnabled(dealer)){
      const sep = this.selectUrl.indexOf('?') == -1 ? '?' : '&';
      const url =  this.selectUrl + sep + 'code=' + dealer.code + '&target_url=' + encodeURIComponent(window.location.href);
      window.Api.GET(url);
      this.scrollToElement($(".js-linking-form"), $("header")[0].offsetHeight);

    }else{

      // afficher le phone
      const btn = this.$view.find('.js-phone[data-dealer="' + dealer.code + '"]');
      btn.html(btn.data('value')).addClass('btn-primary');

      // on efface le formulaire courament sélectionné
      this.$view.find('.js-linking-form').html('');
    }
  }


  showDealer(dealer) {
    console.log('show dealer : ' + dealer.code);

    // remove check / active
    this.$view.find('.custom-control.custom-radio.active input').attr('checked', false);
    this.$view.find('.custom-control.custom-radio.active').removeClass('active');

    // find target
    let listItem = this.$view.find('.custom-control.custom-radio[data-dealer="' + dealer.code + '"]');
    listItem.addClass('active');
    listItem.find('input').attr('checked', true);

    this.scrollParentToChild(this.$list[0], listItem[0]);

    // show popup
    dealer.marker.openPopup();

    // color selected marker
    this.$view.find('.icon-selected').removeClass('icon-selected');
    $(dealer.marker._icon).addClass('icon-selected');
    listItem.find('.marker-icon').addClass('icon-selected');

  }

  // render API

  renderTab(){
    switch (this.tabName){

      case 'linking':
        this.$view.addClass('widget-linking-filtered');
        this.$view.find('.js-linking-tab[data-name=all]').removeClass('active');
        this.$view.find('.js-linking-tab[data-name=linking]').addClass('active');
        this.$view.find('.tab-linking').removeClass('d-none');
        this.$view.find('.tab-all').addClass('d-none');
        this.filterDealerList(false);
        this.countResult(false);

        if (this.$view.find('.icon-selected').hasClass('without-linking')) {
          this.$map.closePopup();
        }

        break;

      case 'all':
        this.$view.removeClass('widget-linking-filtered');
        this.$view.find('.js-linking-tab[data-name=all]').addClass('active');
        this.$view.find('.js-linking-tab[data-name=linking]').removeClass('active');
        this.$view.find('.tab-linking').addClass('d-none');
        this.$view.find('.tab-all').removeClass('d-none');
        this.filterDealerList(true);
        this.countResult(true);

        this.$map.closePopup();
        this.$view.find('.icon-selected').removeClass('icon-selected');

        break;
    }


  }

  renderDealers() {
    this.renderDealerList();
    for (const dealer of this.dealers) {
      this.renderDealerMarker(dealer);
    }
  }

  renderDealerList() {
    let html = '';
    for (const dealer of this.dealers) {
      html += this.renderDealerItem(dealer);
    }
    this.$list.html(html);
  }

  filterDealerList(all = true) {
    let hidden = true;
    for (const dealer of this.inRange) {
      if (dealer.linking) {
        hidden = false;
      }
    }

    if (this.inRange.length == 0 || hidden) {
      this.$list.html('<span class="text-danger">Aucun revendeur n\'est disponible dans la zone sélectionnée</span>');
    }

    if (all) {
      let html = '';
      for (const dealer of this.inRange) {
        html += this.renderDealerItem(dealer);
      }

      if (html != '') {
        this.$list.html(html);
      }
    }

  }

  countResult(all = true) {
    let count = 0;

    for (const dealer of this.dealers) {
      if (all || dealer.linking) {
        count++;
      }
    }

    this.$view.find('.count-dealer-result').html('Résultat(s): ' + count + ' Revendeur(s)');
  }

  renderDealerMarker(dealer) {

    // leaflet marker

    dealer.marker = L.marker([dealer.latitude, dealer.longitude]).addTo(this.$map);

    if (dealer.linking) {
      $(dealer.marker._icon).addClass('with-linking');
    } else {
      $(dealer.marker._icon).addClass('without-linking');
    }

    // popup

    let html = '<div class="info-container">';
    html += '<div class="name">' + dealer.name + '</div>';
    html += '<div class="address">' + dealer.address + " - " + dealer.postcode + " - " + dealer.city + '</div>';
    // html += '<div class="review">Avis à venir</div>';

    if (this.isLinkingEnabled(dealer)){
      html += '<a class="btn btn-block btn-primary js-select-dealer" href data-dealer="' + dealer.code + '">Être mis en relation</a>';
    }

    html += '<a class="btn btn-block btn-primary js-select-dealer js-phone" href data-dealer="' + dealer.code + '" data-value="' + dealer.phone + '">Voir les coordonnées</a>';

    html += '</div>';

    dealer.marker.bindPopup(html);

    // handler

    dealer.marker.on('click', (e) => {
      this.showDealer(dealer);
    });

  }

  // render API

  renderMap() {

    this.$map = L.map('map').setView([46.514005003133704, 2.576351911636036], this.getZoomLevel());

    var tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '<a href="https://leafletjs.com" title=\'A JS library for interactive maps\'>Leaflet</a> &copy;' +
          '© Openstreetmap France &copy; © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      id: 'mapbox/streets-v11',
      tileSize: 512,
      zoomOffset: -1
    }).addTo(this.$map);

    this.$init = false;
  }

  renderDealerItem(dealer) {

    const klass = dealer.linking ? "with-linking" : "without-linking";

    let html = '<div class="form-group ' + klass + '"><div class="custom-control custom-radio" data-dealer="' + dealer.code + '">';
    html += '<input type="radio" id="dealer-' + dealer.code + '" name="dealer" class="custom-control-input">';
    html += '<label class="custom-control-label" for="dealer-' + dealer.code + '">';
    html += '<span class="name">' + dealer.name + '</span> <img class="marker-icon ' + klass + '"><br />';
    html += '<span class="address">' + dealer.address + " - " + dealer.postcode + " - " + dealer.city + '</span><br />';

    let linkingDelay = "Donnée non disponible";
    if (dealer.linkingDelay){

      if (dealer.linkingDelay < 0.5){
        linkingDelay = "inférieur à la demi-journée";

      }else if (dealer.linkingDelay < 2){
        linkingDelay = "1 jour";

      }else{
        linkingDelay = "2 jours";
      }

    }

    html += '<span class="address">Temps de réponse moyen: ' + linkingDelay + '</span>';
    html += '</label>';
    html += '</div></div>';
    return html;

  }

  gtmMenuDealer() {
    if (this.checkoutHash) {
      window.dataLayer.push({"event":"form-menu-dealer","dealer-menu-select":this.checkoutHash});
    }
  }

  gtmMerConfirm() {
    let res = this.readHash(this.H_CODE) + "|";
    if (this.checkoutHash) {
      window.dataLayer.push({"event":"form-contact-dealer-success","dealer":res + this.checkoutHash});
    } else {
      window.dataLayer.push({"event":"form-contact-dealer-success","dealer":res + this.readDealerMenuHash()});
    }
  }

  // helpers

  findDealerByCode(code) {
    for (const dealer of this.dealers) {
      if (dealer.code == code) {
        return dealer;
      }
    }
    return null;
  }

  isLinkingEnabled(dealer){
    return dealer.linking && !this.linkingDisabled;
  }

  // map helpers

  getZoomLevel() {
    let deviceWidth = $(window).width();
    let zoomLevel = 5;
    if (deviceWidth < 414) {
      zoomLevel = 6;
    } else if (deviceWidth >= 414 && deviceWidth < 768) {
      zoomLevel = 7;
    }
    return zoomLevel;
  }

  zoomToPoint(point, radius) {

    let hidden = true;
    this.inRange = [];

    for (let dealer of this.dealers) {
      // Already check radius in API
      // let d = point.distanceTo(dealer.marker.getLatLng());
      // let km = parseFloat((d / 1000).toFixed(2));
      // if (km <= radius) {
      this.inRange.push(dealer);

      if (dealer.linking) {
        hidden = false;
      }

      // }
    }

    // Create bounds from first Marker then extend it with the rest
    const bounds = L.latLngBounds([point]);
    this.inRange.forEach((dealer) => {
      bounds.extend(dealer.marker.getLatLng());
    });

    // Fit the map with the visible markers bounds
    this.$map.flyToBounds(bounds, {
      padding: L.point(36, 36), animate: true,
    });

    if (this.inRange.length == 0 || hidden) {
      this.$view.find('.js-linking-tab[data-name="all"]').click();
    }

    this.filterDealerList();

  }


  scrollParentToChild(parent, child) {

    // Where is the parent on page
    var parentRect = parent.getBoundingClientRect();
    // What can you see?
    var parentViewableArea = {
      height: parent.clientHeight,
      width: parent.clientWidth
    };

    // Where is the child
    var childRect = child.getBoundingClientRect();
    // Is the child viewable?
    var isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

    // if you can't see the child try to scroll parent
    if (!isViewable) {
      // Should we scroll using top or bottom? Find the smaller ABS adjustment
      const scrollTop = childRect.top - parentRect.top;
      const scrollBot = childRect.bottom - parentRect.bottom;
      if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
        // we're near the top of the list
        parent.scrollTop += scrollTop;
      } else {
        // we're near the bottom of the list
        parent.scrollTop += scrollBot;
      }
    }

  }

  // hash helpers

  readHash(key){
    const parts = window.location.hash.split('#');
    for (let part of parts){
      if (part.startsWith(key + ':')){
        return part.substr(key.length + 1);
      }
    }
    return null;
  }

  readDealerMenuHash() {
    let hash = "";
    const parts = window.location.hash.split('#');
    for (let part of parts) {
      if (!part.startsWith('code:') && !part.startsWith('tab:')) {
        hash += part;
      }
    }
    return hash;
  }

  writeHash(key, value){
    const parts = window.location.hash.split('#');
    const result = [];
    for (let part of parts) {
      if (part.startsWith(key)) {
        continue;
      }
      result.push(part);
    }

    if (value){
      result.push(key + ':' + value);
    }

    window.location.hash = result.join('#');
  }

  scrollToElement(element, offset = 0) {
    $('html, body').animate({
      scrollTop: element.offset().top - offset
    }, 1000);
  }



}
